exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul{list-style:none!important;padding-left:0!important;padding-right:0!important}li{padding-left:15px}div{background-color:#003767;padding:20px 20px 20px 5px;color:#fff}div.title{border-bottom:1px solid #4d7395;padding:5px;text-overflow:ellipsis;white-space:pre-line;overflow:hidden}div.title.selected{background-color:#194b76}div.title:hover{background-color:#335f85;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/generic/navigation-menu/navigation-menu.component.css
// module id = 213
// module chunks = 0